import React, {Component} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Redirect} from 'react-router-dom';
import {Link} from 'react-router-dom';
import logo from './logo.png';
import userProfile from './default_profile.png';

class HeaderViews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            asd_username: '',
            my_account: 'text-black',
            users: 'text-black',
            dashboard: 'text-black',
            inpersonateFlag: localStorage.getItem('inpersonate'),
        };
        this.Header = this.Header.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.myAccountSetting = this.myAccountSetting.bind(this);
    }

    componentDidMount() {
        const userId = localStorage.getItem('userId');
        const inpersonate_id = localStorage.getItem('inpersonate_id');
        var inpersonate = localStorage.getItem('inpersonate')
            ? localStorage.getItem('inpersonate')
            : '';
        const pathname = window.location.pathname;
        if ('/create-edit' === pathname) {
            this.setState({my_account: ' bg-orange text-white'});
        } else if ('/users' === pathname) {
            this.setState({users: ' bg-orange text-white'});
        } else if ('/' === pathname) {
            this.setState({dashboard: ' bg-orange text-white'});
        }
        if (userId !== '' && userId !== null) {
            const get_token = localStorage.getItem('token');
            let obj = {id: userId, token: get_token};
            if (inpersonate == 'true') {
                obj.id = inpersonate_id;
            }
            const requestOptions = {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(obj),
            };
            fetch(`./wp-json/asd/users/get`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.user_info !== false && data.code !== 'jwt_auth_invalid_token') {
                        this.setState({asd_username: data.user_info.data.display_name});
                    } else {
                        localStorage.removeItem('token');
                        window.location.href = './asd-login';
                    }
                });
        }
    }

    state = {
        redirect: false,
    };

    setRedirect = () => {
        this.setState({
            redirect: true,
        });
    };

    handleLogout() {
        localStorage.removeItem('token');
        localStorage.removeItem('inpersonate');
        localStorage.removeItem('userId');
        localStorage.removeItem('userRole');
        localStorage.removeItem('inpersonate_user');
        localStorage.removeItem('inpersonate_id');
        localStorage.removeItem('value');
        localStorage.removeItem('profiletab');

        window.location.href = '/';
    }

    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect to={{pathname: '/'}} />;
        }
    };

    myAccountSetting() {
        const userId = localStorage.getItem('userId');
        if ('' !== userId && null !== userId) {
            let inpersonate = localStorage.getItem('inpersonate');
            if (inpersonate != 'true') {
                localStorage.setItem('inpersonate_id', userId);
            }
            window.location.href = './myaccount';
        }
    }

    Header() {
        const useStyles = makeStyles(theme => ({
            root: {
                flexGrow: 1,
            },
            menuButton: {
                //marginRight: theme.spacing(2),
            },
            title: {
                flexGrow: 1,
                color: '#fff',
                textDecoration: 'none',
            },
        }));
        const classes = useStyles();
        const isAlreadyAuthenticated = localStorage.getItem('token');
        const userRole = localStorage.getItem('userRole');

        const [ActiveMenu, setMenu] = React.useState('');

        const MenuhandleClick = (event, newValue) => {
            const currentState = ActiveMenu;
            setMenu(!currentState);
            localStorage.removeItem('value');
            localStorage.removeItem('profiletab');
        };

        const MenuhandleClickBlur = (event, newValue) => {
            if (ActiveMenu) {
                setTimeout(() => {
                    const currentState = ActiveMenu;
                    setMenu(!currentState);
                    localStorage.removeItem('value');
                    localStorage.removeItem('profiletab');
                }, 300);
            }
        };
        const inpersonateFlag = localStorage.getItem('inpersonate');
        const inpersonateUser = localStorage.getItem('inpersonate_user')
            ? localStorage.getItem('inpersonate_user')
            : '';
        const handleBacktoLoginUser = (event, newValue) => {
            if (
                event.currentTarget.attributes.getNamedItem('data-impersonation').value === 'true'
            ) {
                localStorage.setItem('inpersonate', true);
            } else {
                localStorage.setItem('inpersonate', false);
            }
            const get_token = localStorage.getItem('token');
            const user_id = localStorage.getItem('userId');
            const requestOptions = {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify({get_token: get_token, user_id: user_id}),
            };
            if (event.currentTarget.id != '') {
                fetch(`./wp-json/asd/users/inpersonate`, requestOptions)
                    .then(response => response.json())
                    .then(userData => {
                        if (
                            'jwt_auth_invalid_token' === userData.code ||
                            'jwt_auth_bad_iss' === userData.code
                        ) {
                            localStorage.removeItem('token');
                            window.location.href = '/asd-login';
                        } else if ('jwt_auth_bad_request' === userData.code) {
                            if (userData.message) {
                                alert(userData.message);
                            }
                        } else if (userData != null) {
                            if (userData.token != null) {
                                localStorage.setItem('token', userData.token);
                                window.location.href = './';
                            }
                        }
                    });
            }
        };

        return (
            <div className={classes.root}>
                <nav id="header" className="bg-white fixed w-full z-20 top-0 shadow">
                    <div className="w-full p-3 mx-auto flex flex-wrap items-center mt-0 ">
                        <div className="w-1/2 pl-2 md:pl-0">
                            <Link to={{pathname: '/'}}>
                                <img
                                    src={logo}
                                    alt="logo"
                                    className="md:w-1/4 lg:w-1/4 xl:w-1/5 sm:w-2/5"
                                />
                            </Link>
                        </div>

                        <div className="w-1/2 pr-8 header-user-profile">
                            {inpersonateFlag == 'true' ? (
                                <div className="inpersonate-user-section">
                                    <button
                                        onClick={handleBacktoLoginUser}
                                        className="back-btn inpersonate-button hover:bg-gray-100 text-gray-800 font-semibold border border-gray-400 rounded shadow text-white"
                                        data-impersonation="false"
                                        id="2"
                                    >
                                        <svg
                                            className="MuiSvgIcon-root jss67 back-icon"
                                            focusable="false"
                                            viewBox="0 0 24 24"
                                            aria-hidden="true"
                                            tabIndex="-1"
                                            title="ArrowBackIos"
                                            data-ga-event-category="material-icons"
                                            data-ga-event-action="click"
                                            data-ga-event-label="ArrowBackIos"
                                        >
                                            <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path>
                                        </svg>
                                        <span className="inpersonate-name">
                                            Back to regular user
                                        </span>
                                    </button>
                                </div>
                            ) : (
                                ''
                            )}
                            <div className="flex relative inline-block float-right">
                                <div className="relative text-sm">
                                    <button
                                        onClick={MenuhandleClick}
                                        onBlur={MenuhandleClickBlur}
                                        id="userButton"
                                        className="flex items-center focus:outline-none mr-4"
                                    >
                                        <img
                                            className="w-8 h-8 rounded-full mr-4"
                                            src={userProfile}
                                            alt="Avatar of User"
                                        />
                                        <span className="hidden md:inline-block">
                                            {this.state.asd_username}
                                        </span>
                                        <svg
                                            className="pl-2 h-2"
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 129 129"
                                            enableBackground="new 0 0 129 129"
                                        >
                                            <g>
                                                <path d="m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z"></path>
                                            </g>
                                        </svg>
                                    </button>
                                    <div
                                        id="userMenu"
                                        className={
                                            ActiveMenu
                                                ? 'bg-white rounded shadow-md mt-2 absolute mt-12 top-0 right-0 min-w-full overflow-auto visible menu-list'
                                                : ' bg-white rounded shadow-md mt-2 absolute mt-12 top-0 right-0 min-w-full overflow-auto invisible menu-list'
                                        }
                                    >
                                        <ul className="list-reset">
                                            <li>
                                                <a
                                                    href="#"
                                                    onClick={this.myAccountSetting.bind(this)}
                                                    className={`menu-list-item px-4 py-2 block text-gray-900 hover:bg-gray-400 no-underline hover:no-underline ${this.state.my_account}`}
                                                >
                                                    My Account
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="/"
                                                    className={`menu-list-item px-4 py-2 block hover:bg-gray-400 no-underline hover:no-underline ${this.state.dashboard}`}
                                                >
                                                    Dashboard
                                                </a>
                                            </li>
                                            {'1' === userRole &&
                                            this.state.inpersonateFlag != 'true' ? (
                                                <li>
                                                    <a
                                                        href="/users"
                                                        className={`menu-list-item px-4 py-2 block hover:bg-gray-400 no-underline hover:no-underline ${this.state.users}`}
                                                    >
                                                        Users
                                                    </a>
                                                </li>
                                            ) : (
                                                ''
                                            )}
                                            <li>
                                                <hr className="border-t mx-2 border-gray-400"></hr>
                                            </li>
                                            <li>
                                                {' '}
                                                {isAlreadyAuthenticated ? (
                                                    <div style={{width: '100%'}}>
                                                        <a
                                                            onClick={this.handleLogout.bind(this)}
                                                            href="#"
                                                            className="menu-list-item px-4 py-2 block text-gray-900 hover:bg-gray-400 no-underline hover:no-underline text-black"
                                                        >
                                                            Logout
                                                        </a>
                                                    </div>
                                                ) : (
                                                    <div>{this.renderRedirect()}</div>
                                                )}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        );
    }

    render() {
        return <this.Header />;
    }
}

export default HeaderViews;
